import { Validateable } from "@models/interfaces";

export class LeveragedTokenSlider extends Validateable {
	public shortBuy: boolean = false;
	public risk: boolean = false;
	public terms: boolean = false;
	public appTestWarning = false;

	public getAllEnabled(appTestWarning: boolean = false, isBuy = false): boolean {
		// Case 1 buy, All must be accepted
		if (appTestWarning && isBuy) {
			return this.risk && this.terms && this.shortBuy && this.appTestWarning;
		}
		// Case 2 buy, NO Warning
		if (!appTestWarning && isBuy) {
			return this.risk && this.terms && this.shortBuy;
		}

		return this.risk && this.terms;
	}

	public wiggleAll(): void {
		if (!this.risk) {
			this.wiggle("risk");
		}
		if (!this.shortBuy) {
			this.wiggle("shortBuy");
		}

		if (!this.terms) {
			this.wiggle("terms");
		}

		if (!this.appTestWarning) {
			this.wiggle("appTestWarning");
		}
	}

	public disableSliders(): void {
		this.shortBuy = false;
		this.risk = false;
		this.terms = false;
		this.appTestWarning = false;
	}
}
